import { AuthenticationClient } from '../authentication/client';
import { modulesToProducts, productNames } from './config';

export interface UserModulesData {
  modules: string[];
  products: string[];
}

export const retrieveUserAccess = async (): Promise<UserModulesData> => {
  const userToken = await AuthenticationClient.getInstance().getAccessToken();
  const endpoint = '/api/users-api/v1/users/user-access';

  const response = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    },
  });
  const data = await response.json();

  return data || { products: [], modules: [] };
};

export const getProductsFromModule = (module: string) => modulesToProducts[module] ?? [];

export const getProductNamesFromModule = (module: string) => getProductsFromModule(module).map(p => productNames[p]);
